import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"

import { spacing, TSelectOption } from "@minuthq/meatball-ui-react"

import { SearchFilter } from "src/components/Filter/SearchFilter"
import { useTaskTypeLabels } from "src/data/taskManagement/hooks/useFetchTaskTableData"
import { TTaskType } from "src/data/taskManagement/taskManagementTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { DropdownSelect } from "src/ui/DropdownSelect/DropdownSelect"

export function TaskTemplateFilters({
  searchString,
  setSearchString,
  taskType,
  setTaskType,
}: {
  searchString: string
  setSearchString: Dispatch<SetStateAction<string>>
  taskType: TTaskType | null
  setTaskType: Dispatch<SetStateAction<TTaskType | null>>
}) {
  const { t, langKeys } = useTranslate()
  const taskTypes = useTaskTypeLabels()

  function handleSearchChanged(searchValue: string) {
    setSearchString(searchValue)
  }

  function handleTaskTypeChange({ option }: { option: TSelectOption<string> }) {
    setTaskType(option.value as TTaskType)
  }

  const taskTypeOptions = Object.entries(taskTypes).map(([type, label]) => ({
    label,
    value: type,
  }))

  return (
    <FilterRowContainer>
      <SearchFilter
        placeholder={t(langKeys.task_management_search_for_template)}
        onChange={handleSearchChanged}
        initialValue={searchString}
        disabled={false}
      />

      <DropdownSelect
        label={t(langKeys.task_management_task_type)}
        options={taskTypeOptions}
        selectedValue={taskType}
        onChange={handleTaskTypeChange}
        onClearSelection={() => setTaskType(null)}
      />
    </FilterRowContainer>
  )
}

const FilterRowContainer = styled.div`
  display: flex;
  gap: ${spacing.M};
  align-items: center;
`
